import { memo } from 'react'
import reduxLink from '../../functions/reduxLink'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

function AddMoreButton({ link, title, icon, carId, customerTypes }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const addNewCar = () => {
    reduxLink(link, dispatch)

    const state = {}
    if (carId) state['carId'] = carId
    if (customerTypes) state['customerTypes'] = customerTypes

    if (state) {
      navigate(`/${link}/new`, { state })
    } else navigate(`/${link}/new`)
  }
  return (
    <button
      type={'button'}
      onClick={addNewCar}
      className="w-full md:w-fit shadow-add-more h-11 mx-auto px-5 py-2.5 text-md font-medium text-white
                flex items-center justify-center bg-blue rounded-md hover:bg-link
                transition-all duration-300 ease-linear whitespace-nowrap
                "
    >
      <span className={'text-white pl-2'}>{title}</span>
      <i className={`icon-${icon} text-white`} />
    </button>
  )
}

export default memo(AddMoreButton)
